import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const statusColors = {
  "Planning": "bg-blue-100 text-blue-700",
  "In Progress": "bg-blue-100 text-blue-700",
  "On Hold": "bg-amber-100 text-amber-700",
  "Completed": "bg-emerald-100 text-emerald-700",
  "Delayed": "bg-red-100 text-red-700",
  "Draft": "bg-slate-100 text-slate-700",
  "draft": "bg-amber-100 text-amber-700",
  "Submitted": "bg-blue-100 text-blue-700",
  "Approved": "bg-emerald-100 text-emerald-700",
  "Rejected": "bg-red-100 text-red-700",
  "Pending": "bg-amber-100 text-amber-700",
  "Paid": "bg-emerald-100 text-emerald-700",
  "Partial": "bg-amber-100 text-amber-700",
  "Unpaid": "bg-red-100 text-red-700",
  "Open": "bg-red-100 text-red-700",
  "Mitigating": "bg-amber-100 text-amber-700",
  "Resolved": "bg-emerald-100 text-emerald-700",
  "Closed": "bg-slate-100 text-slate-700",
  "Active": "bg-emerald-100 text-emerald-700",
  "completed": "bg-green-100 text-green-700",
};

export const formatDate = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "-";

export const formatCurrency = (amount) => `Rs. ${(amount || 0).toLocaleString()}`;
